import { render, staticRenderFns } from "./InscripcionLiga.vue?vue&type=template&id=381b878a"
import script from "./InscripcionLiga.vue?vue&type=script&lang=js"
export * from "./InscripcionLiga.vue?vue&type=script&lang=js"
import style0 from "./InscripcionLiga.vue?vue&type=style&index=0&id=381b878a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports